import * as angular from 'angular';
import { adminVendorsDashboardComponent } from './admin-vendors-dashboard.component';
import { topLevelAdminVendorsComponent } from './top-level-admin-vendors.component';


export const AdminVendorsModule = angular.module('adminVendorsModule', [])
  .component('topLevelAdminVendors', topLevelAdminVendorsComponent)
  .component('adminVendorsDashboard', adminVendorsDashboardComponent)
  .name;
